import visibilityActionTypes from "../actions/visibilityActionTypes";
import roleActionTypes from "../actions/roleActionTypes";

const visibilityBaseReducer = function visibilityReducer(state = null, action) {
    switch (action.type) {
        case visibilityActionTypes.FETCH_VISIBILITY_PENDING:
            return {
                ...state,
                isError: false,
                isPending: true
            };
        case visibilityActionTypes.FETCH_VISIBILITY_SUCCESS:
            return {
                ...state,
                data: action.data,
                isError: false,
                isPending: false
            };
        case visibilityActionTypes.FETCH_VISIBILITY_ERROR:
            return {
                ...state,
                data: null,
                isError: true,
                isPending: false
            };
        case visibilityActionTypes.FETCH_ALL_PENDING:
            return {
                ...state,
                dataAll: null,
                isFetchAllError: false,
                isFetchAllPending: true,
            };
        case visibilityActionTypes.FETCH_ALL_SUCCESS:
            return {
                ...state,
                dataAll: action.data,
                isFetchAllError: false,
                isFetchAllPending: false,
            };
        case visibilityActionTypes.FETCH_ALL_ERROR:
            return {
                ...state,
                dataAll: {},
                isFetchAllPending: false,
                isFetchAllError: true,
                message: action.message,
            };
        case visibilityActionTypes.EDIT_PENDING:
            return {
                ...state,
                isEdit: true,
            };
        case visibilityActionTypes.EDIT_DONE:
            return {
                ...state,
                isEdit: false,
            };
        default:
            return state;
    }
}

function roleReducer(state = {}, action) {
    switch (action.type) {
        case roleActionTypes.FETCH_ALL_PENDING:
            return {
                ...state,
                allRoles: null,
                isFetchRolesError: true,
                isFetchRolesPending: true,
            };
        case roleActionTypes.FETCH_ALL_SUCCESS:
            return {
                ...state,
                allRoles: action.data,
                isFetchRolesError: false,
                isFetchRolesPending: false,
            };
        case roleActionTypes.FETCH_ALL_ERROR:
            return {
                ...state,
                allRoles: {},
                isFetchRolesError: true,
                isFetchRolesPending: false,
                message: action.message,
            };
        default:
            return state;
    }
}

function visibilityReducer(state, action) {
    return roleReducer(visibilityBaseReducer(state, action), action);
}

export { visibilityReducer };